/*eslint-disable*/
export const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER

export const OKTA_CLIENTID = process.env.REACT_APP_OKTA_CLIENTID

export const JANSSEN_OKTA_ISSUER = process.env.REACT_APP_JANSSEN_OKTA_ISSUER

export const JANSSEN_OKTA_CLIENTID = process.env.REACT_APP_JANSSEN_OKTA_CLIENTID

export const OKTA_BASE_REDIRECT_URI =
  process.env.REACT_APP_OKTA_BASE_REDIRECT_URI

export const OKTA_CONFIG = {
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENTID,
  redirectUri: `${OKTA_BASE_REDIRECT_URI}/login/callback`,
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    window.location.replace(originalUri)
  },
}

export const JANSSEN_OKTA_CONFIG = {
  issuer: JANSSEN_OKTA_ISSUER,
  clientId: JANSSEN_OKTA_CLIENTID,
  redirectUri: `${OKTA_BASE_REDIRECT_URI}/login/callback`,
  restoreOriginalUri: async (oktaAuth, originalUri) => {
    window.location.replace(originalUri)
  },
}
